import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'removeCommas',
    standalone: true
})

export class RemoveCommasPipe implements PipeTransform {
    transform(value: string | null): string | null {
        if (typeof value === 'string') {
            return value.replace(/,/g, '');
        }
        return value;
    }
}